<template>
  <main>
    <section class="video-intro">
      <h1>Contrology Event Video</h1>
    </section>

    <nav>
      <router-link to="event-videos" title="See all event videos"><img src="@/assets/icon-standard-arrow-left.svg" alt="Back arrow icon">all videos</router-link>
    </nav>

    <div class="video-container">
      <iframe title="This is an embedded iframe video" width="996" height="560" src="https://www.youtube.com/embed/TOIgRuxiMLI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>

    <div class="wide-flex-wrapper">
      <section class="video-description">
        <h2>Caged Lion: An Interview with John Howard Steel</h2>
        <p>Original Air Date: September 14, 2020</p>
        <p>What was Joseph Pilates really like? <a href="https://www.johnhowardsteel.com/" style="color:black">John Howard Steel</a> knows.</p>
        <p>John is one of few people who knew Joseph Pilates in and out of his studio.  Serving as attorney and confidant to Joe and Clara, John has a unique perspective on who they were as teachers and people.</p>
        <p>His new book <a href="https://www.amazon.com/Caged-Lion-Joseph-Pilates-Legacy/dp/1733430709/" style="color:black"><em><u><b>"Caged Lion: Joseph Pilates and His Legacy"</b></u></em></a>, recounts the years he spent with the couple and Joe's difficult path to legitimizing his Contrology exercise method. Something that seems hard-to-believe given the popularity of Pilates today.</p>
        <p><a href="https://benjamindegenhardt.com/" style="color:black">Benjamin Degenhart</a> interviews John about his experiences with Joe and Clara and why he decided to finally write about them. <b>Includes a Q and A following the interview.</b></p>
        <p>This will undoubtedly shed light on what has been somewhat of a murky history of Pilates.</p>
      </section>

      <hr>

      <section class="video-speakers">
        <h3>Featured Speakers</h3>
        <div class="video-speakers-container">
          <div class="video-speaker">
            <img
              src="https://s3.amazonaws.com/s3.pilates.com/contrology/banner/john-steel@1x.jpg"
              srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/banner/john-steel@2x.jpg 2x"
              alt="Photo of John Steel"
            />
            <div class="video-speaker-content">
              <p><a href="https://www.johnhowardsteel.com/"><b>John Steel</b></a></p>
            </div>
          </div>

          <div class="video-speaker">
            <img
              src="https://s3.amazonaws.com/s3.pilates.com/contrology/banner/benjamin-degenhardt@1x.jpg"
              srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/banner/benjamin-degenhardt@2x.jpg 2x"
              alt="Photo of Benjamin Degenhardt"
            />
            <div class="video-speaker-content">
              <p><a href="https://benjamindegenhardt.com/"><b>Benjamin Degenhardt</b></a></p>
            </div>
          </div>

        </div>
      </section>
    </div>
    
  </main>
</template>

<script>
  export default {
    name: "videointerview",

    metaInfo: {
      title: "Classical Pilates Interview with John Howard Steel - The Caged Lion",
      titleTemplate: "%s",
      meta: [
        {
          name: "description",
          content: "Listen to this captivating interview with John Howard Steel, the author of the book, The Caged Lion, on Joseph Pilates' life. Watch this fascinating interview now."
        },
        {
          property: "og:image",
          content: "https://s3.amazonaws.com/s3.pilates.com/contrology/videointerview.jpg"
        }
      ]
    },
  }
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  flex-flow: column nowrap;
  margin: 20px 0 30px;
  max-width: 996px;
  margin: 0 auto;
}

nav a {
  text-transform: uppercase;
  font-family: var(--rob);
  font-size: 1.125rem;
  line-height: 1.278;
  font-weight: 700;
  color: #333;
  text-decoration: none;
  padding: 7px 0;
  display: flex;
  justify-content: flex-start;
}

nav img {
  margin-right: 15px;
}

.video-container { 
  position: relative; 
  padding-bottom: 56.25%; 
  padding-top: 30px; 
  height: 0; 
  overflow: hidden; 
  max-width: 996px;
  margin: 0 auto 40px;
}

.video-container iframe,
.video-container object,
.video-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%;
  max-height: 560px;
}

.video-description p {
  font-size: 0.9375rem;
  line-height: 1.4667;
}

hr {
  border: 0;
  border-top: 1px solid #333;
  width: 100%;
  margin: 30px 0;
}

h3 {
  text-align: left;
}

.video-speakers {
  width: 275px;
  margin: 0 auto;
}

.video-speaker {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  margin-bottom: 12px;
}

.video-speaker img {
  width: 100px;
  height: 100px;
  display: block;
  margin-right: 12px;
}

.video-speaker-content p {
  margin: 0 0 10px 0;
}

.video-speaker-content p a {
  color: #000;
}

ol li {
  margin: 10px 0;
}

@media only screen and (max-width:374px) {
  .video-speakers {
    width: 250px;
    margin: -10px
  }
}

@media only screen and (min-width:800px) {
  .video-intro {
    margin: 0 auto;
  }

  .wide-flex-wrapper {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
  }

  hr {
    display: none;
  }

  .video-description {
    margin-right: 40px;
  }
}

@media only screen and (min-width:955px) {
  .video-intro {
    max-width: 650px;
  }
}

@media only screen and (min-width:1080px) {
  .video-container { 
    padding-bottom: 0;
    height: 560px;
  }
}
</style>